import request from '@/utils/request'

/**
 * 获取所有健康评级（不分页，用于下拉列表）
 * @returns {Promise}
 */
export function getAllHealthRatings() {
  return request({
    url: '/health-ratings/list',
    method: 'get'
  })
}

// 分页查询健康评级
export function searchHealthRatings(params) {
  return request({
    url: '/health-ratings/search',
    method: 'post',
    data: params || {}
  })
}

// 根据ID获取健康评级
export function getHealthRatingById(id) {
  return request({
    url: `/health-ratings/${id}`,
    method: 'get'
  })
}

// 新增健康评级
export function addHealthRating(data) {
  console.log('发送新增评级请求，数据:', JSON.stringify(data));
  return request({
    url: '/health-ratings',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 更新健康评级
export function updateHealthRating(id, data) {
  console.log('发送更新评级请求，ID:', id, '数据:', JSON.stringify(data));
  return request({
    url: `/health-ratings/${id}`,
    method: 'put',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 删除健康评级
export function deleteHealthRating(id) {
  console.log('发送删除评级请求，ID:', id);
  return request({
    url: `/health-ratings/${id}`,
    method: 'delete'
  })
} 